import {
    switchRegion,
    exportQrcode,
    qiniuUploadToken,
    uploadQiniu,
    login,
    logout,
    getInfoByDomain,
    randomImage,
    getVerificationCode,
    checkVerificationCode,
    resetSysUserPasswordByMail,
    listWithButtons,
    admList,
    apiAdd,
    apiDelete,
    apiEdit,
    apiList,
    menuManagementAdd,
    menuManagementDelete,
    menuManagementEdit,
    menuManagementAddButton,
    menuManagementEditButton,
    menuManagementDeleteButton,
    roleManagementList,
    roleManagementListAll,
    roleManagementAdd,
    roleManagementDelete,
    roleManagementInfo,
    roleManagementEdit,
    departmentManagementListAll,
    departmentManagementInfo,
    departmentManagementDelete,
    departmentManagementAdd,
    accountManagementList,
    accountManagementAdd,
    accountManagementDelete,
    accountManagementResetPassword,
    accountManagementShare,
    accountManagementInfo,
    accountManagementEdit,
    appAdvertisingList,
    userList,
    userListInfo,
    userListDelete,
    verifyList,
    feedbackList,
    feedbackTextSee,
    feedbackExport,
    appAdvertisingGetFunctionCode,
    appAdvertisingAdd,
    appAdvertisingDelete,
    appAdvertisingEdit,
    appAgreementList,
    appAgreementGetFunctionCode,
    appAgreementAdd,
    appAgreementDelete,
    appAgreementEdit,
    versionManagementList,
    versionManagementSave,
    versionManagementDelete,
    versionManagementUpdate,
    versionReviewReviewList,
    versionReviewReview,
    platformList,
    getAppCodes,
    bikeCategoryListAll,
    platformAdd,
    platformInfoById,
    platformEdit,
    platformDelete,
    platformResetPlatformAdminPassword,
    platformSharePlatformInfo,
    equipmentModeList,
    equipmentModeGetBelongCategoryId,
    equipmentModeAdd,
    equipmentModeListAll,
    equipmentModeDelete,
    equipmentModeEdit,
    equipmentList,
    equipmentInfo,
    equipmentListCompile,
    equipmentListAdd,
    equipmentListDelete,
    equipmentListEdit,
    equipmentListExportExcel,
    equipmentListGetBikeController,
    equipmentListUpdateByBatchId,
    equipmentListUpdateByBikeCode,
    importDevicetemplate,
    importMasterplate,
    firmwareManagementList,
    firmwareManagementListAllBikeType,
    firmwareManagementListAllCategory,
    firmwareManagementListAll,
    firmwareManagementAdd,
    firmwareManagementDelete,
    firmwareManagementEdit,
    firmwareManagementDisable,
    firmwareManagementListAllSuitableHwVersion,
    listALlDistinctHwVersion,
    listAllFwVersion,
    grayScaleTestList,
    grayScaleTestAdd,
    grayScaleTestInfo,
    grayScaleTestCancelGrayTask,
    UpgradeTaskList,
    UpgradeTaskAdd,
    UpgradeTaskDelete,
    UpgradeTaskExportBluetoothTaskInfo,
    UpgradeTaskRestart,
    UpgradeTaskInfo,
    UpgradeListInfo,
    getBindBikeByUserId,
    UpgradeTaskRequestDeviceUpgrade,
    getBindInfoByBikeCode,
    updateFingerMac,
    getLockRecordByBikeCode,
    findAllBatchId,
    findAllBikeTypeName,
    unbindUserAndBike,
    getTrackDataByAppUserId,
    getBikeDataAnalysis,
    getDataStatistics,
    bikeLocationData,
    platformLocationData,
    platformBikeData,
    getUserTotal,
    getCreateUserTotal,
    appUserRegisterData,
    getRidingMileage,
    getRidingActiveCycling,
    platformListAll,
    appLogList,
    geoAddFence,
    geoDelFence,
    geoEditFence,
    geoIotData,
    geoClearData,
    queryList,
    devInfo,
    cmdSend,
    cmdList,
    geoList,
    iotQueryList,
    equipmentListGetAddInfo,
    queryAppRequestUrl,
    listGeoInBike,
    relationBike,
    disassociateBike,
    resetSelfPassword,
    getFailInfo,
    listRidingGeoFence,
    networkList,
    networkAdd,
    networkEdit,
    networkDelete,
    simcardList,
    summaryInfo,
    userRefresh,
    protocolList,
    protocolEdit,
    protocolDelete,
    codeList,
    errCodeEdit,
    errorLang,
    langEdit,
    errCodeDelete,
    faultBikeList,
    workOrderList,
    workChatList,
    replyChat,
    getProtocol,
    langTemplate,
    langImport
} from './api'
export default class Request {
    constructor() { }

     //多语言导入上传
    static langImport = (params) => {
        return langImport(params);
    }

    //多语言导入模版下载
    static langTemplate = (params) => {
        return langTemplate(params);
    }

    //获取故障协议列表
    static getProtocol = (params) => {
        return getProtocol(params);
    }

    //回复客户工单
    static replyChat = (params) => {
        return replyChat(params);
    }

    //获取交流记录
    static workChatList = (params) => {
        return workChatList(params);
    }

    //获取工单列表
    static workOrderList = (params) => {
        return workOrderList(params);
    }

    //车辆故障列表
    static faultBikeList = (params) => {
        return faultBikeList(params);
    }

    //区域切换
    static switchRegion = (url, name) => {
        return switchRegion(url, name);
    }

    //下载二维码
    static exportQrcode = (url, name) => {
        return exportQrcode(url, name);
    }

    //获取七牛云token等
    static qiniuUploadToken = () => {
        return qiniuUploadToken();
    }

    /**
     * 上传七牛
     */
    static uploadQiniu = (params) => {
        return uploadQiniu(params);
    }

    /**
     * 获取平台方信息
     */
    static getInfoByDomain = (params) => {
        return getInfoByDomain(params);
    }


    /**
     * 获取验证码
     */
    static randomImage = (params) => {
        return randomImage(params);
    }


    /**
     * 登录
     */
    static login = (params) => {
        return login(params);
    }

    /**
    * web后台退出登录
    */
    static logout = (params) => {
        return logout(params);
    }


    /**
    * 忘记密码获取验证码
    */
    static getVerificationCode = (params) => {
        return getVerificationCode(params);
    }

    /**
   * 忘记密码-验证验证码
   */
    static checkVerificationCode = (params) => {
        return checkVerificationCode(params);
    }


    /**
     * 忘记密码-根据邮箱地址重设密码
     */
    static resetSysUserPasswordByMail = (params) => {
        return resetSysUserPasswordByMail(params);
    }

    /**
     * 修改密码
     */
    static resetSelfPassword = (params) => {
        return resetSelfPassword(params);
    }

    /**
     * 查询所有菜单带按钮
     */
    static listWithButtons = (params) => {
        return listWithButtons(params);
    }

    /**
    * 新增菜单
    */
    static menuManagementAdd = (params) => {
        return menuManagementAdd(params);
    }

    /**
    * 删除菜单
    */
    static menuManagementDelete = (params) => {
        return menuManagementDelete(params);
    }

    /**
    * 编辑菜单
    */
    static menuManagementEdit = (params) => {
        return menuManagementEdit(params);
    }

    /**
    * 新增按钮
    */
    static menuManagementAddButton = (params) => {
        return menuManagementAddButton(params);
    }


    /**
    * 编辑按钮
    */
    static menuManagementEditButton = (params) => {
        return menuManagementEditButton(params);
    }


    /**
   * 删除按钮
   */
    static menuManagementDeleteButton = (params) => {
        return menuManagementDeleteButton(params);
    }


    /**
    * 角色管理-列表（分页）
    */
    static roleManagementList = (params) => {
        return roleManagementList(params);
    }

    /**
   * 角色管理-查询所有角色
   */
    static roleManagementListAll = (params) => {
        return roleManagementListAll(params);
    }



    /**
    * 新增角色
    */
    static roleManagementAdd = (params) => {
        return roleManagementAdd(params);
    }

    /**
    * 角色管理删除角色
    */
    static roleManagementDelete = (params) => {
        return roleManagementDelete(params);
    }

    /**
    * 角色管理-根据id查询菜单按钮权限
    */
    static roleManagementInfo = (params) => {
        return roleManagementInfo(params);
    }


    /**
    * 角色管理-编辑
    */
    static roleManagementEdit = (params) => {
        return roleManagementEdit(params);
    }


    /**
    * 部门管理-查询所有部门
    */
    static departmentManagementListAll = (params) => {
        return departmentManagementListAll(params);
    }


    /**
    * 账号管理-列表（分页）
    */
    static accountManagementList = (params) => {
        return accountManagementList(params);
    }

    /**
    * 账号管理-新增
    */
    static accountManagementAdd = (params) => {
        return accountManagementAdd(params);
    }

    /**
    * 账号管理-编辑
    */
    static accountManagementEdit = (params) => {
        return accountManagementEdit(params);
    }


    /**
    * 账号管理-删除
    */
    static accountManagementDelete = (params) => {
        return accountManagementDelete(params);
    }


    /**
    * 账号管理-重置密码
    */
    static accountManagementResetPassword = (params) => {
        return accountManagementResetPassword(params);
    }


    /**
    * 账号管理-一键分享
    */
    static accountManagementShare = (params) => {
        return accountManagementShare(params);
    }


    /**
    * 账号管理，根据id查详情
    */
    static accountManagementInfo = (params) => {
        return accountManagementInfo(params);
    }


    /**
    * 部门管理-根据id查询
    */
    static departmentManagementInfo = (params) => {
        return departmentManagementInfo(params);
    }


    /**
     * 部门管理-删除部门
     */
    static departmentManagementDelete = (params) => {
        return departmentManagementDelete(params);
    }


    /**
     * 部门管理-新增部门
     */
    static departmentManagementAdd = (params) => {
        return departmentManagementAdd(params);
    }


    /**
     * app广告-列表（分页）
     */
    static appAdvertisingList = (params) => {
        return appAdvertisingList(params);
    }

    /**
     * app广告-查出所有应用路径
     */
    static appAdvertisingGetFunctionCode = (params) => {
        return appAdvertisingGetFunctionCode(params);
    }


    /**
     * app广告-新增
     */
    static appAdvertisingAdd = (params) => {
        return appAdvertisingAdd(params);
    }


    /**
     * app广告-删除
     */
    static appAdvertisingDelete = (params) => {
        return appAdvertisingDelete(params);
    }


    /**
     * app广告-编辑
     */
    static appAdvertisingEdit = (params) => {
        return appAdvertisingEdit(params);
    }


    /**
     * app协议-列表（分页）
     */
    static appAgreementList = (params) => {
        return appAgreementList(params);
    }


    /**
     * app协议-查出所有协议的应用路径
     */
    static appAgreementGetFunctionCode = (params) => {
        return appAgreementGetFunctionCode(params);
    }

    /**
     * app协议-新增
     */
    static appAgreementAdd = (params) => {
        return appAgreementAdd(params);
    }

    /**
    * app协议-删除
    */
    static appAgreementDelete = (params) => {
        return appAgreementDelete(params);
    }

    /**
     * app协议-编辑
     */
    static appAgreementEdit = (params) => {
        return appAgreementEdit(params);
    }


    /**
     * APP版本-分页列表查询
     */
    static versionManagementList = (params) => {
        return versionManagementList(params);
    }

    /**
     * APP版本-新增
     */
    static versionManagementSave = (params) => {
        return versionManagementSave(params);
    }

    /**
     * 根据流水号查询导入进度
     */
    static equipmentListGetAddInfo = (params) => {
        return equipmentListGetAddInfo(params);
    }

    /**
     * APP版本-批量删除
     */
    static versionManagementDelete = (params) => {
        return versionManagementDelete(params);
    }


    /**
     * APP版本-修改
     */
    static versionManagementUpdate = (params) => {
        return versionManagementUpdate(params);
    }


    /**
     * 查询所有待审核app版本
     */
    static versionReviewReviewList = (params) => {
        return versionReviewReviewList(params);
    }


    /**
     *  审核
     */
    static versionReviewReview = (params) => {
        return versionReviewReview(params);
    }


    /**
     * 平台方管理-列表（分页）
     */
    static platformList = (params) => {
        return platformList(params);
    }

    /**
     * 平台方管理-新增
     */
    static platformAdd = (params) => {
        return platformAdd(params);
    }

    /**
     * 平台方管理-根据id查询
     */
    static platformInfoById = (params) => {
        return platformInfoById(params);
    }


    /**
    * 平台方管理-编辑
    */
    static platformEdit = (params) => {
        return platformEdit(params);
    }

    /**
    * 平台方管理-删除 {id}.action
    */
    static platformDelete = (params) => {
        return platformDelete(params);
    }

    /**
   * 平台方-重置密码
   */
    static platformResetPlatformAdminPassword = (params) => {
        return platformResetPlatformAdminPassword(params);
    }


    /**
     * 平台方-一键分享 
     */
    static platformSharePlatformInfo = (params) => {
        return platformSharePlatformInfo(params);
    }



    /**
     * 获取appcode
     */
    static getAppCodes = (params) => {
        return getAppCodes(params);
    }


    /**
     * 车辆类别-查询所有
     */
    static bikeCategoryListAll = (params) => {
        return bikeCategoryListAll(params);
    }






    /**
     * 管理后台操作日志记录
     */
    static admList = (params) => {
        return admList(params);
    }

    /**
     * 添加日志类别
     */
    static apiAdd = (params) => {
        return apiAdd(params);
    }

    /**
     * 删除日志类别
     */
    static apiDelete = (params) => {
        return apiDelete(params);
    }

    /**
     * 修改日志类别
     */
    static apiEdit = (params) => {
        return apiEdit(params);
    }

    /**
     * 日志类别查询
     */
    static apiList = (params) => {
        return apiList(params);
    }




    /**
    * app用户管理-列表（分页）
    */
    static userList = (params) => {
        return userList(params);
    }
    /**
    * app用户管理-查看详情
    */
    static userListInfo = (params) => {
        return userListInfo(params);
    }
    /**
    * app用户管理-删除
    */
    static userListDelete = (params) => {
        return userListDelete(params);
    }
    /**
    * 用户验证码-列表（分页）
    */
    static verifyList = (params) => {
        return verifyList(params);
    }

    /**
    * app用户管理-根据用户id查询旗下所有绑定车辆
    */
    static getBindBikeByUserId = (params) => {
        return getBindBikeByUserId(params);
    }


    /**
    * 根据用户id查询骑行记录带轨迹（分页）
    */
    static getTrackDataByAppUserId = (params) => {
        return getTrackDataByAppUserId(params);
    }



    /**
    /**
    * 意见反馈-列表（分页）
    */
    static feedbackList = (params) => {
        return feedbackList(params);
    }
    /**
    * 意见反馈-查看详情
    */
    static feedbackTextSee = (params) => {
        return feedbackTextSee(params);
    }
    /**
    * 意见反馈-导出
    */
    static feedbackExport = (params) => {
        return feedbackExport(params);
    }




    /**
    * 车辆型号-列表（分页）
    */
    static equipmentModeList = (params) => {
        return equipmentModeList(params);
    }
    /**
    * 车辆型号-根据id查询
    */
    static equipmentModeGetBelongCategoryId = (params) => {
        return equipmentModeGetBelongCategoryId(params);
    }
    /**
    * 车辆型号-新增
    */
    static equipmentModeAdd = (params) => {
        return equipmentModeAdd(params);
    }
    /**
    * 车辆型号-查询所有
    */
    static equipmentModeListAll = (params) => {
        return equipmentModeListAll(params);
    }
    /**
    * 车辆型号-删除
    */
    static equipmentModeDelete = (params) => {
        return equipmentModeDelete(params);
    }
    /**
    * 车辆型号-编辑
    */
    static equipmentModeEdit = (params) => {
        return equipmentModeEdit(params);
    }




    /**
    * 车辆列表-列表（分页）
    */
    static equipmentList = (params) => {
        return equipmentList(params);
    }
    /**
    * 车辆列表-根据id查询
    */
    static equipmentInfo = (params) => {
        return equipmentInfo(params);
    }
    /**
    * 车辆列表-编辑
    */
    static equipmentListCompile = (params) => {
        return equipmentListCompile(params);
    }
    /**
    * 车辆列表-导入车辆-新增或更新
    */
    static equipmentListAdd = (params) => {
        return equipmentListAdd(params);
    }
    /**
    * 车辆列表-删除
    */
    static equipmentListDelete = (params) => {
        return equipmentListDelete(params);
    }
    /**
    * 车辆列表-更改车辆其他信息
    */
    static equipmentListEdit = (params) => {
        return equipmentListEdit(params);
    }
    /**
    * 车辆列表-导出
    */
    static equipmentListExportExcel = (params) => {
        return equipmentListExportExcel(params);
    }
    /**
    * 车辆列表-查询车辆的实时状态
    */
    static equipmentListGetBikeController = (params) => {
        return equipmentListGetBikeController(params);
    }
    /**
    * 车辆列表-根据批次号更新
    */
    static equipmentListUpdateByBatchId = (params) => {
        return equipmentListUpdateByBatchId(params);
    }

    /**
    * 导入车辆模板
    */
    static importDevicetemplate = (params) => {
        return importDevicetemplate(params);
    }

    /**
    * 批量更换车辆型号模板
    */
    static importMasterplate = (params) => {
        return importMasterplate(params);
    }


    /**
    * 车辆列表-批量更换
    */
    static equipmentListUpdateByBikeCode = (params) => {
        return equipmentListUpdateByBikeCode(params);
    }

    /**
   * 车辆列表-根据批次号更新-批次ID下拉框
   */
    static findAllBatchId = (params) => {
        return findAllBatchId(params);
    }

    /**
   * 车辆列表-根据批次号更新-新车辆型号下拉框
   */
    static findAllBikeTypeName = (params) => {
        return findAllBikeTypeName(params);
    }


    /**
     * 车辆列表-根据车辆编码解绑当前绑定的主用户
     */
    static unbindUserAndBike = (params) => {
        return unbindUserAndBike(params);
    }


    /**
     * 车辆列表-根据车辆编码查询绑定记录
     */
    static getBindInfoByBikeCode = (params) => {
        return getBindInfoByBikeCode(params);
    }

     /**
     * 车辆列表-根据车辆编码更换指纹蓝牙地址
     */
     static updateFingerMac = (params) => {
        return updateFingerMac(params);
    }


    /**
     * 车辆列表-根据车辆编码查询开关锁记录
     */
    static getLockRecordByBikeCode = (params) => {
        return getLockRecordByBikeCode(params);
    }


    /**
     * 车辆列表-根据车辆id返回数据分析结果
     */
    static getBikeDataAnalysis = (params) => {
        return getBikeDataAnalysis(params);
    }


    /**
    * 固件管理-列表（分页）
    */
    static firmwareManagementList = (params) => {
        return firmwareManagementList(params);
    }
    /**
    * 固件管理-查询所有的车辆型号（筛选）
    */
    static firmwareManagementListAllBikeType = (params) => {
        return firmwareManagementListAllBikeType(params);
    }
    /**
    * 固件管理-查询所有的车辆类别
    */
    static firmwareManagementListAllCategory = (params) => {
        return firmwareManagementListAllCategory(params);
    }
    /**
    * 固件管理-查询所有硬件版本
    */
    static firmwareManagementListAll = (params) => {
        return firmwareManagementListAll(params);
    }
    /**
    * 固件管理-新增
    */
    static firmwareManagementAdd = (params) => {
        return firmwareManagementAdd(params);
    }
    /**
    * 固件管理-删除
    */
    static firmwareManagementDelete = (params) => {
        return firmwareManagementDelete(params);
    }
    /**
    * 固件管理-编辑
    */
    static firmwareManagementEdit = (params) => {
        return firmwareManagementEdit(params);
    }
    /**
    * 固件管理-禁用
    */
    static firmwareManagementDisable = (params) => {
        return firmwareManagementDisable(params);
    }
    /**
    * 固件管理- 查看所有适配的硬件版本
    */
    static firmwareManagementListAllSuitableHwVersion = (params) => {
        return firmwareManagementListAllSuitableHwVersion(params);
    }


    /**
    * 灰度配置-查询硬件版本
    */
    static listALlDistinctHwVersion = (params) => {
        return listALlDistinctHwVersion(params);
    }

    /**
    * 固件管理-查询所有适配的固件名称
    */
    static listAllFwVersion = (params) => {
        return listAllFwVersion(params);
    }



    /**
    * 灰度测试-任务列表（分页）
    */
    static grayScaleTestList = (params) => {
        return grayScaleTestList(params);
    }
    /**
    * 灰度测试-灰度配置
    */
    static grayScaleTestAdd = (params) => {
        return grayScaleTestAdd(params);
    }
    /**
    * 灰度测试-任务详情 根据id查询
    */
    static grayScaleTestInfo = (params) => {
        return grayScaleTestInfo(params);
    }



    /**
    * 正式升级任务-任务列表（分页）
    */
    static UpgradeTaskList = (params) => {
        return UpgradeTaskList(params);
    }
    /**
    * 正式升级任务-发布任务
    */
    static UpgradeTaskAdd = (params) => {
        return UpgradeTaskAdd(params);
    }
    /**
    * 正式升级任务-撤回
    */
    static UpgradeTaskDelete = (params) => {
        return UpgradeTaskDelete(params);
    }
    /**
    * 正式升级任务-导出任务详情
    */
    static UpgradeTaskExportBluetoothTaskInfo = (params) => {
        return UpgradeTaskExportBluetoothTaskInfo(params);
    }
    
    /**
    * 固件升级-恢复再次升级
    */
    static UpgradeTaskRestart = (params) => {
        return UpgradeTaskRestart(params);
    }
    /**
   * 升级任务-任务升级详情
   */
    static UpgradeListInfo = (params) => {
        return UpgradeListInfo(params);
    }

    /**
    * 正式升级任务-任务详情 根据id查询
    */
    static UpgradeTaskInfo = (params) => {
        return UpgradeTaskInfo(params);
    }

    /**
    * 上传app查询到的硬件信息并查询是否能升级
    */
    static UpgradeTaskRequestDeviceUpgrade = (params) => {
        return UpgradeTaskRequestDeviceUpgrade(params);
    }


    /**
     * 统计-数据统计
     */
    static getDataStatistics = () => {
        return getDataStatistics();
    }


    /**
     * 查询车辆的坐标图表
     */
    static bikeLocationData = () => {
        return bikeLocationData();
    }


    /**
     * 客户地域分布
     */
    static platformLocationData = () => {
        return platformLocationData();
    }

    /**
     * 查询平台车辆数据饼图
     */
    static platformBikeData = () => {
        return platformBikeData();
    }


    /**
     * 累计用户统计数据分析图
     */
    static getUserTotal = () => {
        return getUserTotal();
    }

    /**
    * 查询平台方的新增用户注册图表信息
    */
    static getCreateUserTotal = (params) => {
        return getCreateUserTotal(params);
    }


    /**
    * 查询平台方的新增用户注册图表信息(平台方)
    */
    static appUserRegisterData = (params) => {
        return appUserRegisterData(params);
    }


    /**
   *  骑行里程统计图
   */
    static getRidingMileage = (params) => {
        return getRidingMileage(params);
    }

    /**
     *  骑行活跃度统计图
     */
    static getRidingActiveCycling = (params) => {
        return getRidingActiveCycling(params);
    }

    /**
     *  查询平台方列表
     */
    static platformListAll = () => {
        return platformListAll();
    }


    /**
    *  APP操作日志记录
    */
    static appLogList = (params) => {
        return appLogList(params);
    }

    /**
    *  快捷搜索-根据条件查询app接口
    */
    static queryAppRequestUrl = (params) => {
        return queryAppRequestUrl(params);
    }

    /**
    *  在线设备列表查询
    */
    static queryList = (params) => {
        return queryList(params);
    }

    /**
    *  查询设备详情信息
    */
    static devInfo = (params) => {
        return devInfo(params);
    }

    /**
    *  下发指令
    */
    static cmdSend = (params) => {
        return cmdSend(params);
    }

    /**
    *  下发指令
    */
    static cmdList = (params) => {
        return cmdList(params);
    }


    /**
     *  查询电子围栏列表
     */
    static geoList = (params) => {
        return geoList(params);
    }


    /**
     *  添加电子围栏
     */
    static geoAddFence = (params) => {
        return geoAddFence(params);
    }


    /**
     *  删除电子围栏
     */
    static geoDelFence = (params) => {
        return geoDelFence(params);
    }


    /**
     *  修改电子围栏
     */
    static geoEditFence = (params) => {
        return geoEditFence(params);
    }


    /**
     *  获取车辆实时数据
     */
    static geoIotData = (params) => {
        return geoIotData(params);
    }


    /**
     *  清空车辆实时数据
     */
    static geoClearData = (params) => {
        return geoClearData(params);
    }


    /**
    * 查询在线设备列表
    */
    static iotQueryList = (params) => {
        return iotQueryList(params);
    }



    /**
    * 灰度测试，取消灰度测试
    */
    static grayScaleTestCancelGrayTask = (params) => {
        return grayScaleTestCancelGrayTask(params);
    }


    /**
    * 管理车辆-车辆列表
    */
    static listGeoInBike = (params) => {
        return listGeoInBike(params);
    }

    /**
     * 管理车辆-关联车辆
     */
    static relationBike = (params) => {
        return relationBike(params);
    }



    /**
     * 关联车辆-取消关联车辆
     */
    static disassociateBike = (params) => {
        return disassociateBike(params);
    }


    /**
    * 下载错误报告
    */
    static getFailInfo = (params) => {
        return getFailInfo(params);
    }

    /**
    * 查询全部电子围栏列表
    */
    static listRidingGeoFence = (params) => {
        return listRidingGeoFence(params);
    }


    /**
    * 服务网点-分页查询
    */
    static networkList = (params) => {
        return networkList(params);
    }


    /**
    * 新增服务网点
    */
    static networkAdd = (params) => {
        return networkAdd(params);
    }


    /**
    * 编辑服务网点
    */
    static networkEdit = (params) => {
        return networkEdit(params);
    }


    /**
    * 删除服务网点
    */
    static networkDelete = (params) => {
        return networkDelete(params);
    }

    /**
    * 查询SIM卡列表
    */
    static simcardList = (params) => {
        return simcardList(params);
    }

    /**
    * SIM卡摘要信息
    */
    static summaryInfo = (params) => {
        return summaryInfo(params);
    }


    /**
     * 刷新用户信息
     */
    static userRefresh = (params) => {
        return userRefresh(params);
    }

    //通讯协议列表
    static protocolList = () => {
        return protocolList();
    }
 
    //新增编辑通讯协议
    static protocolEdit = (params) => {
        return protocolEdit(params);
    }

    //删除通讯协议
    static protocolDelete = (params) => {
        return protocolDelete(params);
    }

    //获取错误代码列表
    static codeList = (params) => {
        return codeList(params);
    }

    //故障代码提交保存
    static errCodeEdit = (params) => {
        return errCodeEdit(params);
    }

    //删除故障代码
    static errCodeDelete = (params) => {
        return errCodeDelete(params);
    }

    //获取错误代码多语言定义
    static errorLang = (params) => {
        return errorLang(params);
    }

    //提交错误代码多语言定义
    static langEdit = (params) => {
        return langEdit(params);
    }

}